import React from "react";
import DriverSidebar from "../components/DriverSidebar";
import ProfileHeader from "../components/ProfileHeader";
import DriverDashboard from "../components/DriverDashboard";

const DriverDashboardPage = () => {
  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      {/* Sidebar on the left */}
      <DriverSidebar />

      {/* Main content area */}
      <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        {/* Profile Header at the top */}
        <ProfileHeader />

        {/* Dashboard content */}
        <div style={{ padding: "20px", flex: 1 }}>
          <DriverDashboard />
        </div>
      </div>
    </div>
  );
};

export default DriverDashboardPage;
